export default __webpack_public_path__ + "static/media/maydhruva_logo.196ee6d8.png";